(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form-blubom"] && !Shopify.designMode) return;
  try {
    /*
    Visibility of the order fields is pure CSS (:has), so the form works without JS.
    This element keeps hidden controls out of the submitted data (otherwise the email
    would carry an empty or duplicated "Zamówienie" line), makes the order number required
    only while it is shown, and adds the admin lookup link for guests.
  */
  if (!customElements.get('blubom-contact-form')) {
    customElements.define(
      'blubom-contact-form',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', this.sync);
          // Capture phase: runs before any listener on the form itself (e.g. hCaptcha)
          this.addEventListener('submit', this.fillCustomerLookup, true);
          this.sync();
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.sync);
          this.removeEventListener('submit', this.fillCustomerLookup, true);
        }

        sync = () => {
          this.fillCustomerLookup();

          const toggle = this.querySelector('.blubom-contact__order-toggle input[type="checkbox"]');
          if (!toggle) return;

          const select = this.querySelector('[data-order-select]');
          const text = this.querySelector('[data-order-text]');
          const enabled = toggle.checked;
          const wantsOther = !select || select.value === '__other';
          // Field name is taken from the markup once, so it lives in one place only
          if (select && !select.dataset.fieldName) select.dataset.fieldName = select.getAttribute('name');

          if (select) {
            select.disabled = !enabled;
            // Keep the select interactive, but don't send the "__other" marker
            if (enabled && !wantsOther) {
              select.setAttribute('name', select.dataset.fieldName);
            } else {
              select.removeAttribute('name');
            }
          }

          if (text) {
            const active = enabled && wantsOther;
            text.disabled = !active;
            text.required = active;
            text.setAttribute('aria-required', String(active));
          }
        };

        // Guests: admin search link by the email they typed. Refreshed on every change
        // and once more at submit, so autofill and last-second edits are covered.
        fillCustomerLookup = () => {
          const lookup = this.querySelector('[data-customer-lookup]');
          if (!lookup) return;

          const email = this.querySelector('input[type="email"]')?.value.trim();
          lookup.disabled = !email;
          lookup.value = email ? lookup.dataset.adminBase + encodeURIComponent(email) : '';
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sku"] && !Shopify.designMode) return;
  try {
    /* Click on the SKU line copies the SKU alone (not the label) and shows a
    short confirmation next to it. One delegated listener on the document, so
    it survives section re-renders. The value is read at click time from the
    element product-sku.js updates on variant change (ref="sku"). The message
    element is created here and sits outside that element, so a variant
    change never overwrites it. The text comes from data-copied-label,
    which the block renders from the locale files. */
  (() => {
    const VISIBLE_MS = 2000;
    const FADE_MS = 400;

    const copyText = async (text) => {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {
        // Fall through to the legacy path (older browsers, restricted contexts).
      }

      const area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.top = '0';
      area.style.opacity = '0';
      document.body.append(area);
      area.select();

      let copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }
      area.remove();
      return copied;
    };

    const showMessage = (component) => {
      const container = component.querySelector('[ref="skuContainer"]') || component;
      const label = component.dataset.copiedLabel || '';

      let message = container.querySelector('.sku-copied');
      const isNew = !message;
      if (isNew) {
        message = document.createElement('span');
        message.className = 'sku-copied';
        message.setAttribute('role', 'status');
        container.append(message);
      }

      clearTimeout(message.hideTimer);
      clearTimeout(message.removeTimer);

      // A live region announces text that changes after it exists, so a new
      // element gets its text one frame later.
      if (isNew) {
        requestAnimationFrame(() => (message.textContent = label));
      } else {
        message.textContent = label;
      }
      message.classList.add('is-visible');

      message.hideTimer = setTimeout(() => {
        message.classList.remove('is-visible');
        message.removeTimer = setTimeout(() => message.remove(), FADE_MS + 50);
      }, VISIBLE_MS);
    };

    document.addEventListener('click', async (event) => {
      if (!(event.target instanceof Element)) return;

      const target = event.target.closest('product-sku-component .sku-label, product-sku-component .sku');
      if (!target) return;

      const component = target.closest('product-sku-component');
      const value = component.querySelector('[ref="sku"]')?.textContent.trim();
      if (!value) return;

      if (await copyText(value)) showMessage(component);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
